import { useEffect, useState } from 'react'
import { useSelector } from '@/libs/state'
import { session$ } from '@/features/auth/store'
import { useIntlayer } from 'react-intlayer'

const getGreetingKey = (): 'morning' | 'afternoon' | 'evening' => {
	const hour = new Date().getHours()
	if (hour >= 5 && hour < 12) return 'morning'
	if (hour >= 12 && hour < 17) return 'afternoon'
	return 'evening'
}

const WelcomeGreeting = () => {
	const content = useIntlayer('overview')
	const user = useSelector(() => session$.user.get())
	const [greetingKey, setGreetingKey] = useState<'morning' | 'afternoon' | 'evening'>(getGreetingKey)

	useEffect(() => {
		const id = setInterval(
			() => {
				setGreetingKey(getGreetingKey())
			},
			5 * 60 * 1000,
		)
		return () => clearInterval(id)
	}, [])

	const firstName = user?.fullName?.split(' ')[0]
	const greeting = content.greeting[greetingKey]

	return (
		<h1 className='text-[38px] font-serif leading-tight text-center'>
			{greeting}
			{firstName ? (
				<>
					, <span className='text-muted-foreground'>{firstName}</span>
				</>
			) : null}
		</h1>
	)
}

export { WelcomeGreeting }
